// src/string.ts
var toUpperCase = (str) => str.toUpperCase();
var toLowerCase = (str) => str.toLowerCase();
var isInteger = (string) => /^\d+$/.test(string);
var split = (str, delimiter) => str.split(delimiter);
var capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
var uncapitalize = (str) => `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
var isHex = (str) => /^0x[\da-f]+$/i.test(str);
var isBytes = (str) => /^(0x)?[\da-f]*$/i.test(str) && str.length % 2 === 0;
var abbreviate = (text, showLength = 4, space = false) => {
  if (typeof text !== "string") return "";
  const leftPart = text.slice(0, showLength);
  const rightPart = text.slice(text.length - showLength);
  return [leftPart, rightPart].join(space ? ". . ." : "\u2026");
};
var truncateString = (string, numCharacters = 20, ellipsis = true) => {
  if (string.length < numCharacters) return string;
  let slicedString = string.slice(0, numCharacters);
  if (ellipsis) {
    slicedString += "...";
  }
  return slicedString;
};
export {
  abbreviate,
  capitalize,
  isBytes,
  isHex,
  isInteger,
  split,
  toLowerCase,
  toUpperCase,
  truncateString,
  uncapitalize
};
